import { useEffect, useState } from "react";

/** Subscribe to a CSS media query. */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

/** True below Tailwind `sm` (640px). */
export function useIsMobile() {
  return !useMediaQuery("(min-width: 640px)");
}

/** True below Tailwind `md` (768px). */
export function useIsNarrow() {
  return !useMediaQuery("(min-width: 768px)");
}

/** True at Tailwind `xl`+ (1280px). */
export function useIsWide() {
  return useMediaQuery("(min-width: 1280px)");
}
